import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import { post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";

const Pending = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const [overallList, setOverallList] = useState();

  const dashboardList = async (val) => {
    let res = await post(URLS.DASHBOARD_LIST);
    if (res?.status == "success") {
      if (res?.overall_ticket) {
        setOverallList(res?.overall_ticket);
      }
    }
  };

  useEffect(() => {
    dashboardList();
  }, []);

  const stats = [
    {
      label: "Pending",
      value: overallList?.super_admin_pending ?? "0",
      path: "/pending-table",
    },
    {
      label: "Inventory",
      value: overallList?.inventory_pending ?? "0",
      path: "/inventory-table",
    },
    {
      label: "Technical",
      value: overallList?.technical_pending ?? "0",
      path: "/technical-table",
    },
    {
      label: "Next Visit",
      value: overallList?.next_visit_pending ?? "0",
      path: "/next-visit",
    },
    {
      label: "Senior Service Engineer Support",
      value: overallList?.senior_support_pending ?? "0",
      path: "/service-table",
    },
  ];

  const handleClick = (index, path) => {
    setActiveIndex(index);
    navigate(path);
  };

  return (
    <div>
      <Topbar header="Pending" subHead="Move" />
      <div className="container_fluit1 px-4 py-3">
        <div className="d-flex flex-wrap gap-3 ac-js">
          {stats.map((item, index) => (
            <div
              key={index}
              className={`box_Value d-flex ac-jc ${
                activeIndex === index ? "box_Value_active" : ""
              }`}
              onClick={() => handleClick(index, item.path)}
              style={{ cursor: "pointer" }}
            >
              <button
                className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                style={{
                  border: "none",
                  background: "transparent",
                  color: activeIndex === index ? "white" : "black",
                }}
              >
                {`${item.label} - ${item.value}`}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pending;
